import {Fragment} from 'react'
import {ActionList} from '@primer/react'

import {SUBSCRIPTION_TYPES} from '../utils/subscriptions'

import styles from './SubscriptionList.module.css'

interface SubscriptionListProps {
  selected: string
  onSelect: (value: string) => void
}

function SubscriptionList(props: SubscriptionListProps) {
  return (
    <ActionList selectionVariant="single">
      {SUBSCRIPTION_TYPES.map((item, index) => (
        // eslint-disable-next-line @eslint-react/no-array-index-key
        <Fragment key={index}>
          <ActionList.Item
            selected={item.subscriptionType === props.selected}
            onSelect={() => props.onSelect(item.subscriptionType)}
          >
            <span className={styles.subscriptionTypeName}>{item.name}</span>
            <ActionList.Description variant="block">{item.description}</ActionList.Description>
            {item.trailingIcon ? <ActionList.TrailingVisual>{item.trailingIcon}</ActionList.TrailingVisual> : null}
          </ActionList.Item>
          {index !== SUBSCRIPTION_TYPES.length - 1 ? <ActionList.Divider /> : ''}
        </Fragment>
      ))}
    </ActionList>
  )
}

export default SubscriptionList

try{ SubscriptionList.displayName ||= 'SubscriptionList' } catch {}